<script>

export default {
  name: 'NumberField',
  props: {
    value: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    inner_value: null
  }),
  watch: {
    value () {
      this.inner_value = this.parseNumber(this.value);
    },
    inner_value (val) {
      this.inner_value = this.parseNumber(this.inner_value);
      this.updateValue();
    }
  },
  created () {
    this.inner_value = this.parseNumber(this.value);
  },
  methods: {
    updateValue () {
      this.$emit('input', this.parseNumber(this.inner_value));
    },
    parseNumber (str) {
      const val = parseFloat(('' + str).replace(/[^0-9,.+-]/, '').replace(',', '.'));
      return isNaN(val) ? null : val;
    }
  }
};
</script>

<template>
  <v-text-field
    v-model="inner_value"
    lang="en"
    type="number"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-text-field>
</template>
